import { doodBlockConfig, propertyValue } from './dood-block-config';
import { cartPagePresetBlockBackgroundColorProperty } from './cart-page-preset-block-background.util';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

/** Serializable runtime state used by `CartTipPickerBlockComponent` preview scenarios. */
export type CartTipPickerBlockScenarioContent = {
  tipsAllowed: boolean;
  /** Cart total in display currency units (not cents). */
  totalAmount: number;
  /** Already selected tip in display currency units (not cents). */
  selectedTip: number;
};
export const CARTTIPPICKERBLOCK_LEGACY_FIELD_ORDER = [
  "choice_1_amount",
  "choice_1_unit",
  { type: 'separator' },
  "choice_2_amount",
  "choice_2_unit",
  { type: 'separator' },
  "choice_3_amount",
  "choice_3_unit",
  { type: 'separator' }
] as const satisfies readonly DescriptorFieldOrderItem[];

const tipUnitChoices = [
  {
    value: "currency",
    label: "pages.blocks.cart-tip-picker.unit.options.currency",
  },
  {
    value: "percent",
    label: "pages.blocks.cart-tip-picker.unit.options.percent",
  },
] as const;

const {
  cartTipPickerBlockDescriptor: _generatedCartTipPickerBlockDescriptor,
  cartTipPickerBlockBlocDefinition,
  cartTipPickerBlockDashboardLayout,
  cartTipPickerBlockConfig,
  cartTipPickerBlockResolveConfig,
  cartTipPickerBlockProperties,
  cartTipPickerBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Cart - Tip picker",
    componentType: 'CartTipPickerBlockComponent',
    category: 'cart',
    description: "Cart - Tip picker.",
    keywords: [],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },
  () => ({
    background_color: cartPagePresetBlockBackgroundColorProperty(),
    choice_1_amount: propertyValue({
      type: 'number',
      value: 1,
      options: {
        label: "pages.blocks.cart-tip-picker.amount.label",
        placeholder: "1",
      }
    }),
    choice_1_unit: propertyValue({
      type: 'select',
      value: "currency",
      options: {
        label: "pages.blocks.cart-tip-picker.unit.label",
        multiple: false,
        choices: [...tipUnitChoices],
      }
    }),
    choice_2_amount: propertyValue({
      type: 'number',
      value: 2,
      options: {
        label: "pages.blocks.cart-tip-picker.amount.label",
        placeholder: "2",
      }
    }),
    choice_2_unit: propertyValue({
      type: 'select',
      value: "currency",
      options: {
        label: "pages.blocks.cart-tip-picker.unit.label",
        multiple: false,
        choices: [...tipUnitChoices],
      }
    }),
    choice_3_amount: propertyValue({
      type: 'number',
      value: 5,
      options: {
        label: "pages.blocks.cart-tip-picker.amount.label",
        placeholder: "5",
      }
    }),
    choice_3_unit: propertyValue({
      type: 'select',
      value: "currency",
      options: {
        label: "pages.blocks.cart-tip-picker.unit.label",
        multiple: false,
        choices: [...tipUnitChoices],
      }
    })
  }),
  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-tip-picker.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-page.fieldset.appearance.label",
            fields: ["background_color"],
          },
          {
            legend: "pages.blocks.cart-tip-picker.fieldset.choice-1.label",
            fields: ["choice_1_amount", "choice_1_unit"],
          },
          {
            legend: "pages.blocks.cart-tip-picker.fieldset.choice-2.label",
            fields: ["choice_2_amount", "choice_2_unit"],
          },
          {
            legend: "pages.blocks.cart-tip-picker.fieldset.choice-3.label",
            fields: ["choice_3_amount", "choice_3_unit"],
          },
        ],
      },
    ],
  })
);

export function cartTipPickerBlockDescriptor(): IBlockDescriptor;
export function cartTipPickerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartTipPickerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartTipPickerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartTipPickerBlockDescriptor, cartTipPickerBlockProperties, fieldOrder);
}

export {
  cartTipPickerBlockBlocDefinition,
  cartTipPickerBlockDashboardLayout,
  cartTipPickerBlockProperties,
  cartTipPickerBlockConfig,
  cartTipPickerBlockResolveConfig,
  cartTipPickerBlockDefinitionSetupScenarios,
};

export type CartTipPickerBlockConfig = typeof cartTipPickerBlockConfig;
